import Mousetrap from "mousetrap";

// eslint-disable-next-line func-names
Mousetrap.prototype.stopCallback = function () {
  return false;
};

// eslint-disable-next-line kf/const-naming-convention
export const Hotkey = Mousetrap;
